import { FormEvent } from 'react';
import { IoCheckmark } from 'react-icons/io5';

const Checkbox = ({
  label,
  onClick,
  choosenValues,
  value
}: {
  label: string;
  onClick: (value: string) => void;
  choosenValues: string[];
  value: string;
}) => {
  const isChecked = choosenValues.includes(value);

  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      className={`hover:ag-bg-primary-20 ag-pl-3.5 ag-rounded-md ag-p-[10px] ag-flex ag-items-center ag-flex-row ag-justify-between ag-w-full ${
        isChecked ? 'ag-bg-primary-40' : ''
      }`}
    >
      <span className="ag-text-sm ag-whitespace-nowrap">{label}</span>
      <IoCheckmark
        size="20"
        className={`ag-text-checked-icon ag-duration-200 ag-opacity-0 ${
          isChecked && 'ag-opacity-100'
        }`}
      />
    </button>
  );
};

export default Checkbox;
